{
  "languages": {
    "arabic": "アラビア語",
    "belarusian": "ベラルーシ語",
    "chinese": "中国語",
    "dutch": "オランダ語",
    "english": "英語",
    "french": "フランス語",
    "german": "ドイツ語",
    "italian": "イタリア語",
    "japanese": "日本語",
    "korean": "韓国語",
    "lithuanian": "リトアニア語",
    "portuguese": "ポルトガル語",
    "romanian": "ルーマニア語",
    "spanish": "スペイン語",
    "turkish": "トルコ語"
  }
}
